/** What saving does with the offer PDF – it is no form field, the file is uploaded after the draft is saved. */
export type OfferFileChange = { action: 'keep' } | { action: 'upload'; file: File } | { action: 'remove' };

/** An already stored PDF, as the editor shows it. */
export interface StoredOfferFile {
  name: string;
  size: number;
}

export const KEEP_OFFER_FILE: OfferFileChange = { action: 'keep' };

/** The PDF the offer will have after saving. */
export const getResultingOfferFile = (change: OfferFileChange, stored: StoredOfferFile | null): Pick<File, 'name' | 'size'> | null => {
  if (change.action === 'upload') return change.file;
  if (change.action === 'remove') return null;
  return stored;
};
